import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  imports: [
    MatIconModule,
    TranslateModule,
    CommonModule
  ],
  standalone: true
})

export class NoDataComponent {
  @Input() message: string = 'events.no_data';
  @Input() description?: string;
  @Input() icon: string = 'inbox';
  @Input() size: 'small' | 'medium' = 'medium';
}